/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react'
import Searchbar from 'app/components/Searchbar'

const DataRoomSearchComponent = ({onSearchTermChange,searchTerm,setSearchTerm}) => {
  useEffect(() => {
    onSearchTermChange(searchTerm)
  }, [searchTerm])

  return (
    <div className='card-title'>
      <div className='flex-lg-fill'>
        <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </div>
    </div>
  )
}

export {DataRoomSearchComponent}
